import * as React from "react";
import { Drawer as DrawerPrimitive } from "vaul";

import { cn } from "@/react/shadcn/utils";

const Drawer = ({ shouldScaleBackground = true, ...props }) => (
  <DrawerPrimitive.Root
    shouldScaleBackground={shouldScaleBackground}
    {...props}
  />
);
Drawer.displayName = "Drawer";

const DrawerTrigger = DrawerPrimitive.Trigger;

const DrawerPortal = DrawerPrimitive.Portal;

const DrawerClose = DrawerPrimitive.Close;

const DrawerOverlay = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Overlay> & {
    className?: string;
  }
>(({ className, ...props }, ref) => (
  <DrawerPrimitive.Overlay
    ref={ref}
    className={cn(
      "web3kit-fixed web3kit-inset-0 web3kit-z-20 web3kit-bg-black/80",
      className
    )}
    {...props}
  />
));
DrawerOverlay.displayName =
  DrawerPrimitive.Overlay?.displayName || "DrawerOverlay";

const DrawerContent = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Content> & {
    className?: string;
  }
>(({ className, children, ...props }, ref) => (
  <DrawerPortal>
    <DrawerOverlay />
    <DrawerPrimitive.Content
      ref={ref}
      className={cn(
        "web3kit-fixed web3kit-inset-x-0 web3kit-bottom-0 web3kit-z-20 web3kit-mt-24 web3kit-flex web3kit-h-auto web3kit-flex-col web3kit-rounded-t-[10px] web3kit-border web3kit-bg-background",
        className
      )}
      {...props}
    >
      <div className="web3kit-mx-auto web3kit-mt-4 web3kit-h-2 web3kit-w-[100px] web3kit-rounded-full web3kit-bg-muted" />
      {children}
    </DrawerPrimitive.Content>
  </DrawerPortal>
));
DrawerContent.displayName = "DrawerContent";

const DrawerHeader = ({
  className,
  ...props
}: {
  className: string;
  props: any;
}) => (
  <div
    className={cn(
      "web3kit-grid web3kit-gap-1.5 web3kit-p-4 web3kit-text-center sm:web3kit-text-left",
      className
    )}
    {...props}
  />
);
DrawerHeader.displayName = "DrawerHeader";

const DrawerFooter = ({
  className,
  ...props
}: {
  className: string;
  props: any;
}) => (
  <div
    className={cn(
      "web3kit-mt-auto web3kit-flex web3kit-flex-col web3kit-gap-2 web3kit-p-4",
      className
    )}
    {...props}
  />
);
DrawerFooter.displayName = "DrawerFooter";

const DrawerTitle = React.forwardRef<
  HTMLHeadingElement,
  React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Title> & {
    className?: string;
  }
>(({ className, ...props }, ref) => (
  <DrawerPrimitive.Title
    ref={ref}
    className={cn(
      "web3kit-text-lg web3kit-font-semibold web3kit-leading-none web3kit-tracking-tight",
      className
    )}
    {...props}
  />
));
DrawerTitle.displayName = DrawerPrimitive.Title?.displayName || "DrawerTitle";

const DrawerDescription = React.forwardRef<
  HTMLParagraphElement,
  React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Description> & {
    className?: string;
  }
>(({ className, ...props }, ref) => (
  <DrawerPrimitive.Description
    ref={ref}
    className={cn("web3kit-text-sm web3kit-text-muted-foreground", className)}
    {...props}
  />
));
DrawerDescription.displayName =
  DrawerPrimitive.Description?.displayName || "DrawerDescription";

export {
  Drawer,
  DrawerPortal,
  DrawerOverlay,
  DrawerTrigger,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerFooter,
  DrawerTitle,
  DrawerDescription,
};
